import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './Button';
export function Hero() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <section className="pt-32 pb-24 px-6 md:px-12 relative overflow-hidden" style={{
    backgroundColor: '#F4F6ED'
  }} data-id="element-164">
      {/* Decorative lines */}
      <div className="absolute top-40 left-0 w-24 h-px bg-ink-300 opacity-30" data-id="element-165"></div>
      <div className="absolute top-60 left-10 w-16 h-px bg-ink-300 opacity-30" data-id="element-166"></div>
      <div className="absolute bottom-40 right-0 w-24 h-px bg-ink-300 opacity-30" data-id="element-167"></div>
      <div className="absolute bottom-60 right-10 w-16 h-px bg-ink-300 opacity-30" data-id="element-168"></div>
      <div className="container mx-auto max-w-6xl" data-id="element-169">
        <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-170">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8
        }} className="order-2 md:order-1" data-id="element-171">
            <div className="relative mb-8" data-id="element-172">
              <h1 className="text-4xl md:text-5xl lg:text-6xl font-currency font-normal leading-tight" data-id="element-173">
                <span className="block italic tracking-wide" data-id="element-174">Product</span>
                <span className="text-ink-800 tracking-wide" data-id="element-175">
                  leadership
                </span>{' '}
                for
                <span className="block mt-3 tracking-wide" data-id="element-176">
                  founders and growth teams
                </span>
              </h1>
              <div className="absolute -top-6 -left-6 w-12 h-12 border-t border-l border-ink-300 opacity-40" data-id="element-177"></div>
              <div className="absolute -bottom-6 -right-6 w-12 h-12 border-b border-r border-ink-300 opacity-40" data-id="element-178"></div>
            </div>
            <p className="text-xl text-ink-600 mb-10 max-w-xl font-serif" data-id="element-179">
              Advisory, fractional CPO, and product audits that turn ambiguity
              into shipped outcomes. From shipping code to shaping strategy
              across BrightLocal, MOO, Tesco, and Digikala, I help teams find
              clarity, focus, and momentum when growth appears messy.
            </p>
            <div className="flex flex-col sm:flex-row gap-6" data-id="element-180">
              <Button onClick={() => scrollToSection('contact')} data-id="element-181">
                Book a call
              </Button>
              <Button variant="secondary" onClick={() => scrollToSection('work')} data-id="element-182">
                View case studies
              </Button>
            </div>
          </motion.div>
          <motion.div className="order-1 md:order-2 flex justify-center" initial={{
          opacity: 0,
          scale: 0.9
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} data-id="element-183">
            <div className="relative w-64 h-64 md:w-80 md:h-80 lg:w-96 lg:h-96" data-id="element-184">
              <picture data-id="element-185">
                <source srcSet="https://uploadthingy.s3.us-west-1.amazonaws.com/wDuT26bYAUAG1Pd72nCKEo/portrait_line_engraving_transparent.png" media="(min-width: 1024px)" width="384" height="384" data-id="element-186" />
                <source srcSet="https://uploadthingy.s3.us-west-1.amazonaws.com/wDuT26bYAUAG1Pd72nCKEo/portrait_line_engraving_transparent.png" media="(min-width: 768px)" width="320" height="320" data-id="element-187" />
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/wDuT26bYAUAG1Pd72nCKEo/portrait_line_engraving_transparent.png" alt="Stylized line art portrait illustration" className="w-full h-full object-contain" width="256" height="256" data-id="element-188" />
              </picture>
              <div className="absolute -bottom-6 -right-6 w-32 h-32 rounded-full border border-ink-300 -z-10" data-id="element-189"></div>
              <div className="absolute -top-6 -left-6 w-24 h-24 rounded-full border border-ink-300 -z-10" data-id="element-190"></div>
              <div className="absolute bottom-10 -right-10 w-16 h-16 rounded-full border border-dashed border-ink-300 -z-10" data-id="element-191"></div>
              <div className="absolute -top-10 right-10 w-12 h-12 rounded-full border border-dotted border-ink-300 -z-10" data-id="element-192"></div>
            </div>
          </motion.div>
        </div>
      </div>
      <div className="max-w-4xl mx-auto mt-24 px-6" data-id="element-193">
        <div className="h-px bg-ink-200 w-full" data-id="element-194"></div>
      </div>
    </section>;
}